// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Button. */

.button {
  /* Reset. */
  appearance: none;
  background: none;
  border: none;
}

.button {
  --button-primary-default: light-dark(#1b1b1b, #ffffff);
  --button-primary-hover: light-dark(#696969, #cdcdcd);
  --button-primary-active: light-dark(#9e9e9e, #9e9e9e);
  --button-primary-inactive: light-dark(#1b1b1b, #ffffff);

  --button-secondary-default: light-dark(#ffffff, #4e4e4e);
  --button-secondary-hover: light-dark(#cdcdcd, #858585);
  --button-secondary-active: light-dark(#cdcdcd, #9e9e9e);
  --button-secondary-inactive: light-dark(#f9f9fb, #4e4e4e);
  --button-secondary-border-focus: light-dark(#0085f2, #0085f2);
  --button-secondary-border-red: light-dark(#ff97a0, #ff97a0);
  --button-secondary-border-red-focus: light-dark(#ffd9dc, #ffd9dc);

  /* Defaults. */
  --button-bg--default: var(
    --button-primary-default,
    light-dark(#1b1b1b, #ffffff)
  );
  --button-bg-hover--default: var(
    --button-primary-hover,
    light-dark(#696969, #cdcdcd)
  );
  --button-bg-active--default: var(
    --button-primary-active,
    light-dark(#9e9e9e, #9e9e9e)
  );
  --button-border-color--default: var(
    --button-primary-default,
    light-dark(#1d1d1d, #ffffff)
  );
  --button-color--default: var(
    --color-background-primary,
    light-dark(#ffffff, #1b1b1b)
  );
  --button-focus-border-color--default: var(
    --button-secondary-border-focus,
    #0085f2
  );
  --button-focus-effect--default: var(
    --focus-effect,
    0 0 0 3px var(--accent-primary-engage, #0085f21a)
  );
  --button-gap--default: 0.25rem;
  --button-height--default: var(--form-elem-height, 2rem);
  --button-padding--default: 0.5rem;
  --button-radius--default: var(--elem-radius, 0.25rem);

  /* Layout. */
  display: flex;

  gap: var(--button-gap, var(--button-gap--default));
  place-items: center;

  width: fit-content;
  height: var(--button-height, var(--button-height--default));

  padding: 0 var(--button-padding, var(--button-padding--default));

  color: var(--button-color, var(--button-color--default));

  text-decoration: none;

  /* Interactivity. */
  cursor: pointer;

  /* Visual. */
  background-color: var(--button-bg, var(--button-bg--default));
  border: 1px solid
    var(--button-border-color, var(--button-border-color--default));
  border-radius: var(--button-radius, var(--button-radius--default));
}

/* Button States */

.button:active,
.button.active {
  background-color: var(
    --button-bg-active,
    var(--button-bg, var(--button-bg-active--default))
  );
}

.button:focus,
.button.focus {
  outline: none;
  border: 1px solid
    var(--button-focus-border-color, var(--button-focus-border-color--default));
  box-shadow: var(--button-focus-effect, var(--button-focus-effect--default));
}

.button:hover,
.button.hover {
  /* In most cases, we want the border to be the same color as the background. */
  --button-border-color: var(
    --button-bg-hover,
    var(--button-bg, var(--button-bg-hover--default))
  );

  background-color: var(
    --button-bg-hover,
    var(--button-bg, var(--button-bg-hover--default))
  );
}

.button[disabled],
.button.disabled {
  cursor: default;
  opacity: 0.65;

  &:hover {
    --button-bg-hover: unset;
  }

  &:active {
    --button-bg-active: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./components/button/common.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sDAAsD;EACtD,oDAAoD;EACpD,qDAAqD;EACrD,uDAAuD;;EAEvD,wDAAwD;EACxD,sDAAsD;EACtD,uDAAuD;EACvD,yDAAyD;EACzD,6DAA6D;EAC7D,2DAA2D;EAC3D,iEAAiE;;EAEjE,cAAc;EACd;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,8BAA8B;EAC9B,uDAAuD;EACvD,iCAAiC;EACjC,qDAAqD;;EAErD,YAAY;EACZ,aAAa;;EAEb,kDAAkD;EAClD,mBAAmB;;EAEnB,kBAAkB;EAClB,2DAA2D;;EAE3D,gEAAgE;;EAEhE,wDAAwD;;EAExD,qBAAqB;;EAErB,mBAAmB;EACnB,eAAe;;EAEf,YAAY;EACZ,6DAA6D;EAC7D;mEACiE;EACjE,kEAAkE;AACpE;;AAEA,kBAAkB;;AAElB;;EAEE;;;GAGC;AACH;;AAEA;;EAEE,aAAa;EACb;+EAC6E;EAC7E,2EAA2E;AAC7E;;AAEA;;EAEE,8EAA8E;EAC9E;;;GAGC;;EAED;;;GAGC;AACH;;AAEA;;EAEE,eAAe;EACf,aAAa;;EAEb;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/** Button. */\n\n.button {\n  /* Reset. */\n  appearance: none;\n  background: none;\n  border: none;\n}\n\n.button {\n  --button-primary-default: light-dark(#1b1b1b, #ffffff);\n  --button-primary-hover: light-dark(#696969, #cdcdcd);\n  --button-primary-active: light-dark(#9e9e9e, #9e9e9e);\n  --button-primary-inactive: light-dark(#1b1b1b, #ffffff);\n\n  --button-secondary-default: light-dark(#ffffff, #4e4e4e);\n  --button-secondary-hover: light-dark(#cdcdcd, #858585);\n  --button-secondary-active: light-dark(#cdcdcd, #9e9e9e);\n  --button-secondary-inactive: light-dark(#f9f9fb, #4e4e4e);\n  --button-secondary-border-focus: light-dark(#0085f2, #0085f2);\n  --button-secondary-border-red: light-dark(#ff97a0, #ff97a0);\n  --button-secondary-border-red-focus: light-dark(#ffd9dc, #ffd9dc);\n\n  /* Defaults. */\n  --button-bg--default: var(\n    --button-primary-default,\n    light-dark(#1b1b1b, #ffffff)\n  );\n  --button-bg-hover--default: var(\n    --button-primary-hover,\n    light-dark(#696969, #cdcdcd)\n  );\n  --button-bg-active--default: var(\n    --button-primary-active,\n    light-dark(#9e9e9e, #9e9e9e)\n  );\n  --button-border-color--default: var(\n    --button-primary-default,\n    light-dark(#1d1d1d, #ffffff)\n  );\n  --button-color--default: var(\n    --color-background-primary,\n    light-dark(#ffffff, #1b1b1b)\n  );\n  --button-focus-border-color--default: var(\n    --button-secondary-border-focus,\n    #0085f2\n  );\n  --button-focus-effect--default: var(\n    --focus-effect,\n    0 0 0 3px var(--accent-primary-engage, #0085f21a)\n  );\n  --button-gap--default: 0.25rem;\n  --button-height--default: var(--form-elem-height, 2rem);\n  --button-padding--default: 0.5rem;\n  --button-radius--default: var(--elem-radius, 0.25rem);\n\n  /* Layout. */\n  display: flex;\n\n  gap: var(--button-gap, var(--button-gap--default));\n  place-items: center;\n\n  width: fit-content;\n  height: var(--button-height, var(--button-height--default));\n\n  padding: 0 var(--button-padding, var(--button-padding--default));\n\n  color: var(--button-color, var(--button-color--default));\n\n  text-decoration: none;\n\n  /* Interactivity. */\n  cursor: pointer;\n\n  /* Visual. */\n  background-color: var(--button-bg, var(--button-bg--default));\n  border: 1px solid\n    var(--button-border-color, var(--button-border-color--default));\n  border-radius: var(--button-radius, var(--button-radius--default));\n}\n\n/* Button States */\n\n.button:active,\n.button.active {\n  background-color: var(\n    --button-bg-active,\n    var(--button-bg, var(--button-bg-active--default))\n  );\n}\n\n.button:focus,\n.button.focus {\n  outline: none;\n  border: 1px solid\n    var(--button-focus-border-color, var(--button-focus-border-color--default));\n  box-shadow: var(--button-focus-effect, var(--button-focus-effect--default));\n}\n\n.button:hover,\n.button.hover {\n  /* In most cases, we want the border to be the same color as the background. */\n  --button-border-color: var(\n    --button-bg-hover,\n    var(--button-bg, var(--button-bg-hover--default))\n  );\n\n  background-color: var(\n    --button-bg-hover,\n    var(--button-bg, var(--button-bg-hover--default))\n  );\n}\n\n.button[disabled],\n.button.disabled {\n  cursor: default;\n  opacity: 0.65;\n\n  &:hover {\n    --button-bg-hover: unset;\n  }\n\n  &:active {\n    --button-bg-active: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
